export const PaddingAtom = () => {
  return (
    <div className='h-[20px]'></div>
  )
}

